import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';
import AccionaCheckButton from '../../../../../../components/AccionaCheckButton';
import AcctionaFormItem from '../../../../../../components/AccionaFormItem';
import AccionaInput from '../../../../../../components/AccionaInput';
import AccionaButton from '../../../../../../components/AccionaButton';
import { useNavigate } from 'react-router-dom';

const LaboratoryForm = ({
  formState,
  updateForm,
  moveAllRegions,
  updateMoveAllRegions,
  children,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const onBack = () => navigate(-1);
  return (
    <div className="wrapper" style={{ maxWidth: '1524px' }}>
      <div className="form-row">
        <AccionaButton
          msg={intl.formatMessage({ id: 'back' })}
          onClick={onBack}
          classIcon="icon fas fa-chevron-left"
          style={{ float: 'right', marginTop: '30px', marginRight: '-15px' }}
        />
      </div>
      <div className="row row-project" style={{ paddingBottom: '20px' }}>
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="col-xs-12 col-sm-3 col-md-3">
            <AcctionaFormItem>
              <AccionaInput
                state={formState.templateName}
                disabled
                label="templateName"
                onChange={updateForm}
              />
            </AcctionaFormItem>
          </div>
          <div className="col-xs-12 col-sm-3 col-md-3">
            <AcctionaFormItem>
              <AccionaInput
                state={formState.supplier_id}
                disabled
                label="supplier_id"
                onChange={updateForm}
              />
            </AcctionaFormItem>
          </div>
          <div>
            <div className="col-xs-12 col-sm-2 col-md-2">
              <AcctionaFormItem>
                <AccionaInput
                  state={formState.phone_number}
                  disabled
                  label="phone_number"
                  onChange={updateForm}
                />
              </AcctionaFormItem>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <AcctionaFormItem>
                <AccionaInput
                  state={formState.email}
                  disabled
                  label="email"
                  onChange={updateForm}
                />
              </AcctionaFormItem>
            </div>
          </div>
        </div>
        <div
          className="col-xs-12 col-sm-6 col-md-6"
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <AccionaCheckButton
            active={moveAllRegions}
            updateActive={updateMoveAllRegions}
            msg={intl.formatMessage({ id: 'moveAllRegions' })}
          />
        </div>
      </div>
      {children}
    </div>
  );
};

LaboratoryForm.propTypes = {
  formState: PropTypes.object.isRequired, // TODO: Complete with shape()
  updateForm: PropTypes.func.isRequired,
  moveAllRegions: PropTypes.bool.isRequired,
  updateMoveAllRegions: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default LaboratoryForm;
